import type { TelFilter } from '../est/filters/tel';
import type { RootScope } from '../types';

interface LsLead {
  name?: string;
  phone?: string | null;
  email?: string | null;
  integration?: {
    deal?: {
      name: string | null;
    };
  };
}

export class WorkingWithCtrl {
  showWorkingWith = false;
  lastLeadTooltip = '';
  textNoName = '';
  lead: LsLead | null = null;

  static $inject = [
    '$scope',
    '$window',
    '$timeout',
    '$translate',
    'telFilter',
    'localStorageService',
    '$rootScope',
  ];

  constructor(
    $scope: angular.IScope,
    private $window: angular.IWindowService,
    private $timeout: angular.ITimeoutService,
    $translate: angular.translate.ITranslateService,
    private telFilter: TelFilter,
    private localStorageService: angular.local.storage.ILocalStorageService,
    private $rootScope: RootScope,
  ) {
    this.textNoName = $translate.instant('unit.popup.noname');

    $rootScope.$on('$translateChangeSuccess', () => {
      this.textNoName = $translate.instant('unit.popup.noname');
    });

    $scope.$on('new.ls.lead', () => this.init());

    this.init();
  }

  init() {
    let lsLead: LsLead | null = null;

    if (this.localStorageService.get('lead')) {
      lsLead = this.localStorageService.get('lead');
    }

    if (lsLead) {
      let lastLeadTooltip = '';

      if (typeof lsLead.name === 'undefined') {
        lastLeadTooltip = this.textNoName;
      } else {
        lastLeadTooltip = lsLead.name;
      }

      if (this.$rootScope.embeddedIntegrationName) {
        if (
          typeof lsLead.integration !== 'undefined' &&
          typeof lsLead.integration.deal !== 'undefined' &&
          lsLead.integration.deal.name
        ) {
          lastLeadTooltip += ` [${lsLead.integration.deal.name}]`;
        } else {
          lastLeadTooltip += ` [${this.textNoName}]`;
        }
      } else {
        if (typeof lsLead.phone !== 'undefined' && lsLead.phone !== null) {
          lastLeadTooltip += ` +${this.telFilter(lsLead.phone)}`;
        }

        if (typeof lsLead.email !== 'undefined' && lsLead.email !== null) {
          lastLeadTooltip += ` ${lsLead.email}`;
        }
      }

      this.lastLeadTooltip = lastLeadTooltip.trim();
      this.showWorkingWith = true;
      this.lead = lsLead;
    }
  }

  finishWorkingWith() {
    this.localStorageService.remove('lead');
    this.showWorkingWith = false;

    this.$timeout(() => {
      if (this.$window.location.pathname.startsWith('/appeals')) {
        // if we are on appeals page, just stay where we are
        return;
      }

      this.$window.location.href = '/leads';
    }, 300);
  }
}
